// extracted by mini-css-extract-plugin
export var badge = "_gs-2";
export var detailsPanel = "_gs-0";
export var resultRow = "_gs-1";